import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import { restoreActionInfo } from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectActionRoomStateType
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/RoomActions/SelectActionRoomStateType/SelectActionRoomStateType'
import SelectActionRoomStateTypeIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/RoomActions/SelectActionRoomStateType/SelectActionRoomStateType'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectActionRoomStateTypeIOS) : withStyles(SelectActionRoomStateType)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const {
    isChangeActionMode,
    isChangeActionStateMode,
    isEditActionMode,
    initialAction,
  } = state.scenes.currentSceneCreating
  const { actions } = state.scenes.currentSceneConditionsActions
  return {
    isChangeActionMode,
    isChangeActionStateMode,
    isEditActionMode,
    isMobile,
    actions,
    initialAction,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  restoreActionInfo,
  notifications: syncNotifications.sync,
}, dispatch)

enhance = withAccessDenied(enhance)
enhance = withNotifications(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectActionRoomStateTypeEnhanced = enhance

export default withRouter(SelectActionRoomStateTypeEnhanced)
